import React, { Component } from "react";

import DataTable from 'react-data-table-component';

import Popup from "react-popup";

const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true
};

export default class CuotasPendientes extends Component {
  constructor(props) {
    super(props);


  }



  componentDidMount() {

  }
  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });


  getColumnDetalle() {
    return [
      {
        name: "Cuota",
        selector: row => row.cuota,
        width: "70px",
      },
      {
        name: "Vencimiento",
        selector: row => row.vencimiento
      },
      {
        name: "Capital",
        selector: row => row.capital,
        width: "130px",
        right: true
      },
      {
        name: "Interés",
        selector: row => row.interes,
        right: true
      },
      {
        name: "IVA s/Int.",
        selector: row => row.ivaSinInteres,
        right: true
      },
      {
        name: "Seguro",
        selector: row => row.seguro,
        right: true
      },
      {
        name: "IVA s/Seguro.",
        selector: row => row.ivaSinSeguro,
        right: true
      },
      {
        name: "Total Cuota",
        selector: row => row.total,
        width: "130px",
        right: true
      },
      {
        name: "Estado",
        selector: row => row.estado,
      }
    ];
  }


  render() {


    return (
      <DataTable
        noHeader={true}
        pagination={true}
        columns={this.getColumnDetalle()}
        data={this.props.cuotas}
        dense={true}
        pagination={true}
        paginationComponentOptions={paginationOptions}
        noDataComponent="SIN DATOS"
        responsive={true}
        striped={true} />

    );
  }
}